import { legacy_createStore } from "redux";
import cartReducer from "./reducer";

export const store = legacy_createStore(cartReducer);
